import { render, staticRenderFns } from "./WebAppsList.vue?vue&type=template&id=58df2f10&scoped=true"
import script from "./WebAppsList.vue?vue&type=script&lang=js"
export * from "./WebAppsList.vue?vue&type=script&lang=js"
import style0 from "./WebAppsList.vue?vue&type=style&index=0&id=58df2f10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58df2f10",
  null
  
)

export default component.exports